define('constants/countryEnumerations',[], function() {
    return {
        usa: "us",
        ca: "ca"
    };
});

